import { render, staticRenderFns } from "./RunnitsInfoDialog.vue?vue&type=template&id=3f1abc51&scoped=true"
import script from "./RunnitsInfoDialog.vue?vue&type=script&lang=ts"
export * from "./RunnitsInfoDialog.vue?vue&type=script&lang=ts"
import style0 from "./RunnitsInfoDialog.vue?vue&type=style&index=0&id=3f1abc51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1abc51",
  null
  
)

export default component.exports